import * as React from "react";

function ConectaZapIcon(props) {
  return (
    <svg
      width={22}
      height={18}
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21.98 8.15a7.427 7.427 0 10-5.267 7.64l1.511.827a1.078 1.078 0 001.595-.962l-.027-1.695a7.406 7.406 0 002.189-5.81zm-3.238 5.087a.62.62 0 00-.202.47l.026 1.675-1.49-.816a.632.632 0 00-.502-.042 6.183 6.183 0 112.168-1.287z" />
      <path d="M18.59 9.44l-1.32-.963a.76.76 0 00-.573-.138.755.755 0 00-.502.306l-.408.558c-.021.029-.013.002-.023.038-.002.004-.025.035-.098.047-.123.019-.493-.004-1.292-.643l-.077-.056c-.84-.56-.975-.905-.995-1.028-.01-.063.006-.094.004-.096.027-.017.02-.017.04-.044l.409-.558a.77.77 0 00-.167-1.078l-1.342-.98a.771.771 0 00-1.076.168l-.412.565a1.973 1.973 0 00-.256 1.78c.318.926 1.128 1.91 2.41 2.926a.335.335 0 00.06.056c.032.023.065.046.098.067.03.025.063.048.094.073a.26.26 0 00.071.04c1.359.911 2.542 1.383 3.522 1.404h.038a1.93 1.93 0 001.556-.805l.412-.566a.76.76 0 00-.174-1.073zM2.57 14.455l-.037 2.288a.527.527 0 00.78.47l2.029-1.111a7.893 7.893 0 004.337.224.2.2 0 00.05-.37 8.308 8.308 0 01-4.336-6.93 8.306 8.306 0 014.455-7.7.199.199 0 00-.04-.371 7.902 7.902 0 00-7.238 13.5z" />
    </svg>
  );
}

export default ConectaZapIcon;
